<script lang="ts" setup>
import { computed, ref } from 'vue'
import { Icon } from '@brighterly/lib-lumee-ui'

import { useTracksLiveKit } from '../../model/tracks-live-kit.hook'
import { useMediaBindingLiveKit } from '../../model/media-binding-live-kit.hook'
import { useRoomLiveKit } from '../../model/room-live-kit.hook'

defineOptions({
  name: 'VideoTileLocal',
})

const {
  localCameraTrack,
  isCameraEnabled,
  isMicEnabled,
  isLocalSpeaking,
  cameraError,
} = useTracksLiveKit()

const { localName } = useRoomLiveKit()

const videoEl = ref<HTMLVideoElement | null>(null)

useMediaBindingLiveKit(videoEl, localCameraTrack)

const initial = computed<string>(() => (localName.value ?? '').trim().toUpperCase()[0] || '?')
const isMicMuted = computed<boolean>(() => !isMicEnabled.value)
</script>

<template>
  <div class="video-tile">
    <video
      v-show="isCameraEnabled"
      ref="videoEl"
      class="video-tile__video video-tile__video--mirror"
      autoplay
      playsinline
      muted
    />
    <div
      v-if="!isCameraEnabled"
      class="video-tile__placeholder"
    >
      <div class="video-tile__avatar btly-text-title-xl">
        {{ initial }}
      </div>
      <span
        v-if="cameraError"
        class="video-tile__hint btly-text-body-s"
      >Camera is blocked</span>
    </div>
    <div
      v-if="localName"
      class="video-tile__info btly-text-body-m"
    >
      <span
        v-if="isMicMuted"
        class="video-tile__mic"
      >
        <Icon
          name="microphone-slash"
          size="md"
          color="inherit"
        />
      </span>
      <span
        v-else
        :class="['video-tile__speaking', { 'video-tile__speaking--active': isLocalSpeaking }]"
      >
        <span class="video-tile__speaking-bar" />
        <span class="video-tile__speaking-bar" />
        <span class="video-tile__speaking-bar" />
      </span>
      <span class="video-tile__name">{{ localName }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./VideoTile.scss" />
